import { render, staticRenderFns } from "./DynamicContentDetail.vue?vue&type=template&id=54c89301&scoped=true"
import script from "./DynamicContentDetail.vue?vue&type=script&lang=js"
export * from "./DynamicContentDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicContentDetail.vue?vue&type=style&index=0&id=54c89301&prod&lang=scss"
import style1 from "./DynamicContentDetail.vue?vue&type=style&index=1&id=54c89301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c89301",
  null
  
)

export default component.exports